<template>
  <v-sheet>
    <div id="waveTop"></div>
    <v-container class="py-4 py-lg-8">
      <v-row align="center" justify="center">
        <v-col cols="12" md="6" lg="6">
          <h1>{{ $t('products.obj[3].title') }}</h1>
          <h4>{{ $t('products.obj[3].h4') }}</h4>
          <p>{{ $t('products.obj[3].p1') }}</p>
          <p>{{ $t('products.obj[3].p2') }}</p>
        </v-col>
        <v-col cols="12" md="6" lg="6" class="d-none d-md-block">
          <v-img
            class="rounded-lg"
            :src="EvoMock"
            :max-height="$vuetify.breakpoint.lgAndUp ? 'calc(1000vh - -500px)' : '400'"
            alt=""
          >
          </v-img>
        </v-col>
        <v-col cols="12" class="hidden-md-and-up">
          <v-img height="180" width="373.8" :src="EvoMock" alt=""></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-card
          v-for="(item, i) in $t('products.obj[3].features')"
          :key="i"
          :class="$vuetify.breakpoint.smAndUp ? 'd-flex col-4 mt-10' : 'col-12 mt-10'"
          max-width="500"
          outlined
          style="margin-left: auto; margin-right: auto; margin-bottom: 10px; border-color: white"
        >
          <v-img
            height="50px"
            width="50px"
            :src="Evo[i].img"
            alt=""
            style="margin-left: auto; margin-right: auto;"
          >
          </v-img>
          <div class="ml-3">
            <h5 :style="$vuetify.breakpoint.smAndUp ? '' : 'text-align: center'">
              {{ item.title }}
            </h5>
            <p :style="$vuetify.breakpoint.smAndUp ? '' : 'text-align: center; font-size: 12px'">
              {{ item.subtitle }}
            </p>
          </div>
        </v-card>
      </v-row>
    </v-container>
    <div id="waveButton"></div>
    <v-sheet style="background-color: #001E4A;">
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" md="7" lg="7">
            <v-img
              class="rounded-lg"
              :src="midEvo"
              :max-height="$vuetify.breakpoint.lgAndUp ? 'calc(100vh - 0px)' : '1000'"
              alt=""
            >
            </v-img>
          </v-col>
          <v-col cols="12" md="5" lg="5">
            <v-row
              v-for="(item, i) in $t('products.obj[3].featuresMid')"
              :key="i"
              style="color: white"
            >
              <div class="ml-3">
                <h5
                  :style="
                    $vuetify.breakpoint.smAndUp
                      ? 'font-size: 25px'
                      : 'text-align: center; font-size: 22px'
                  "
                >
                  {{ item.title }}
                </h5>
                <p
                  :style="$vuetify.breakpoint.smAndUp ? '' : 'text-align: center; font-size: 12px'"
                >
                  {{ item.subtitle }}
                </p>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
    <div id="waveTop"></div>
  </v-sheet>
</template>

<script>
import EvoMock from 'Assets/Produtos/Evo/Evo_mock.png';
import midEvo from 'Assets/Produtos/Evo/midEvo.png';
import Interface from 'Assets/Produtos/Evo/Interface.png';
import Liberdade from 'Assets/Produtos/Evo/Liberdade.png';
import TiposDeOrdem from 'Assets/Produtos/Evo/TiposDeOrdem.png';
import Wallet from 'Assets/Produtos/Evo/Wallet.png';
import MotorDeOrdem from 'Assets/Produtos/Evo/MotorDeOrdem.png';
import Suporte from 'Assets/Produtos/Evo/Suporte.png';
export default {
  name: 'Landing',
  data() {
    return {
      EvoMock,
      midEvo,
      Evo: [
        {
          img: Interface,
        },
        {
          img: Liberdade,
        },
        {
          img: Suporte,
        },
        {
          img: Wallet,
        },
        {
          img: MotorDeOrdem,
        },
        {
          img: TiposDeOrdem,
        },
      ],
    };
  },
  components: {},
};
</script>
